import { usePermissionsObject } from "features/permissions/hooks/usePermissionsObject";

export const useConstrControlPermissions = () => {
  const counterpartiesPermissions = usePermissionsObject({
    viewContactsList: false,
    viewAddContact: true,
    viewDeleteContacts: true,
    viewEditContact: true,
    viewContractorsList: true,
    viewAddContractor: true,
    viewDeleteContractors: true,
    viewEditContractorManager: true,
    viewAddContractorsContracts: true,
    viewDeleteContractorsContract: true,
    viewAddContractorsContractFiles: true,
    viewDeleteContractorsContractFiles: true,
    viewSuppliersList: true,
    viewInviteSupplier: true,
    viewDeleteSuppliers: true,
    viewEditSupplierManager: true,
    viewAddSuppliersContracts: true,
    viewDeleteSuppliersContract: true,
    viewAddSuppliersContractFiles: true,
    viewDeleteSuppliersContractFiles: true,
    viewCustomersList: true,
    viewInviteCustomer: true,
    viewDeleteCustomers: true,
    viewEditCustomerManager: true,
    viewAddCustomersContracts: true,
    viewDeleteCustomersContracts: true,
    viewAddCustomersContractsFiles: true,
    viewDeleteCustomersContractsFiles: true,
    viewInvitesList: true,
    viewInvitesListActions: true,
  });

  const buildingPemissions = {
    canAddFiles: true,
    canAddPlan: true,
    canAddProgress: true,
    canDeleteFiles: true,
    canSharePlan: true,
    canShareProgress: true,
    canViewPlan: true,
    canViewProgress: true,
    //drawings
    canAddDrawings: true,
    canAddDrawingSets: true,
    canDeleteDrawingSets: true,
    canDeleteDrawings: true,
    canEditDrawings: true,
    canEditDrawingSets: true,
    canViewDrawings: true,
  };

  return {
    counterpartiesPermissions,
    buildingPemissions,
  };
};
